import { MovieHero, Movie, Festivals } from "arts-and-storytelling";
import * as React from 'react';
export default {
  MovieHero,
  Movie,
  Festivals,
  React
};